import { userReducer } from './userReducer'
import { combineReducers, compose, createStore } from 'redux'
import { TypedUseSelectorHook, useSelector as useReduxSelector } from 'react-redux'

declare global {
	interface Window {
		__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose
	}
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const combinedReducers = combineReducers({
	user: userReducer,
})

export type RootState = ReturnType<typeof combinedReducers>

export const getState: TypedUseSelectorHook<RootState> = useReduxSelector

export const store = createStore(
	combinedReducers,
	process.env.NODE_ENV === 'production' ? void 0 : composeEnhancers()
)


